import Model from 'src/storage/base';

class AddPatientModel extends Model {
  id = 'AddPatientModel';
  defaultState = () => ({
    tab: 'quick',
    selectedDate: null,
    slotsMonth: [],
    slots: [],
    clinics: [],
    scheduleFlg: false
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;
  apiConfig = {
    list: {
      url: 'schedule/list',
      validation: {
        from: 'number',
        to: 'number'
      },
      cancellable: true
    },
    hospitals: {
      url: 'hospital/list',
      validation: {
        skip: 'number',
        limit: 'number'
      },
      cancellable: true
    },
    doctor_list: {
      url: 'clinic/doctor/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    invite: {
      url: '/admin/patient/update',
      validation: {
        email: 'email',
        phoneNumber: 'phoneNumber',
        firstName: 'firstName',
        lastName: 'lastName',
        gender: 'gender',
        birthday: 'birthday',
        countryAddress: 'countryAddress',
        cityAddress: 'cityAddress',
        stateAddress: 'stateAddress',
        address: 'address',
        zipcode: 'zipcode'
      },
      cancellable: true
    },
    detail: {
      url: '/admin/patient/detail',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    }
  };
  _events = {
    profile: 'handleProfile',
    location: 'initLocation'
  };

  initLocation = (data) => {
    this.setState({ tempCountryAddress: data.country });
  };

  handleProfile = (profile) => {
    this.setState({ user: profile });
  };

  reset = () => {
    this.resetApi();
    this.setState({
      patient: null,
      firstName: '',
      lastName: '',
      gender: '',
      birthday: '',
      countryAddress: '',
      stateAddress: '',
      cityAddress: '',
      phoneNumber: '',
      email: '',
      address: '',
      zipcode: '',
      emails: '',
      clinicId: null
    });
  };

  sendInvite = (id, cb) => {
    let { firstName, lastName } = this.state;
    let req = {
      id,
      avatar: this.state.patient.avatar,
      firstName,
      lastName,
      gender: this.state.gender,
      birthday: this.state.birthday,
      countryAddress: this.state.countryAddress || '',
      cityAddress: this.state.cityAddress || '',
      stateAddress: this.state.stateAddress || '',
      phoneNumber: this.state.phoneNumber,
      email: this.state.email,
      address: this.state.address,
      zipcode: this.state.zipcode?.toString() || ''
    };
    this.api('invite', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (success) {
        this.emit('adminUpdatePatient', data);
        this.reset();
      }
    });
  };

  getDetail = (id, cb) => {
    let req = {
      id
    };
    this.api('detail', req, (err, data, success) => {
      cb(err, data, success);
    });
  };
}

const model = new AddPatientModel();
export default model;
